module.exports = __webpack_public_path__ + "static/media/video-green.4500872e.svg";